import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
 filterCarrierData = new BehaviorSubject<any>([])
 private filterCriteria: any;
 private filterState: any = {};
  private searchResults: any[];
  constructor() { }

  setData(value){
    this.filterCarrierData.next(value);
  }
  getData(){
    return this.filterCarrierData.asObservable();
  }
  
  setFilterCriteria(criteria: any) {
    this.filterCriteria = criteria;
  }

  getFilterCriteria() {
    return this.filterCriteria;
  }

  setSearchResults(results: any[]) {
    this.searchResults = results;
  }

  getSearchResults(): Observable<any[]> {
    return of(this.searchResults);
  }
  
  
  setFilterState(filters: any) {
    this.filterState = filters;
  }

  getFilterState() {
    return this.filterState;
  }
}
